import React from 'react';
import { Button, TextField } from "@material-ui/core";
import DatePickerControl from '../../../components/controls/DatePickerControl';
import strings from '../../../localization';
import IconButton from "@material-ui/core/IconButton";


const CardGraveSiteHeader = ({
  graveyardName,
  graveSiteCode,
  famousCitizenCode,
  graveSiteSize,
  graveSiteLength,
  graveSiteWidth,
  graveSiteDepth,
  contractExpiryDate,
  validContract,
  hasCremationStatement,
  expirationDate,
  note,
  contractHolderDeceased,
  deceasedContractGks,
  funeralAtDepth,
}) => (


<React.Fragment>
<div className="card-grave-site-display-flex">
    <div className="card-grave-site-header-width">
      <TextField
        label={strings.mainBookOfBuriedList.graveyard}
        fullWidth
        name='graveyardName'
        margin="normal"
        disabled={true}
        value={graveyardName}
        InputLabelProps={{
          shrink: true,
        }}
      />
      <div className="card-grave-site-display-flex">
        <TextField
          label={strings.mainBookOfBuriedList.graveSite}
          fullWidth
          name='graveSiteCode'
          margin="normal"
          disabled={true}
          value={graveSiteCode}
          InputLabelProps={{
            shrink: true,
          }}
        />
        {/* "Величина" is always shown on the card, empty when the grave site has none. */}
        <TextField
          label={strings.graveSite.form.size}
          fullWidth
          name='graveSiteSize'
          margin="normal"
          disabled={true}
          value={graveSiteSize == null ? "" : graveSiteSize}
          style={{ marginLeft: 10 }}
          InputLabelProps={{
            shrink: true,
          }}
        />
      </div>

      <DatePickerControl
        label={strings.cardGraveSiteList.expiryDateContract}
        placeholder={""}
        name='contractExpiryDate'
        date={contractExpiryDate ? new Date(contractExpiryDate) : contractExpiryDate}
        isClearable={true}
        dateFormat='dd/MM/yyyy'
        disabled={true}
      />

      <TextField
        label={strings.graveSite.form.note}
        multiline={true}
        rows={5}
        fullWidth
        name='note'
        margin="normal"
        disabled={true}
        value={note == null ? "" : note}
        InputLabelProps={{
          shrink: true,
        }}
      />
    </div>
    {(validContract || !contractExpiryDate || (contractExpiryDate && !isNaN(new Date(contractExpiryDate)) && new Date(contractExpiryDate) < new Date())) ? 
      <p className="card-has-no-valid-contract">{strings.cardGraveSiteList.hasNoValidContract}</p> : null
    }
    {hasCremationStatement ?
      <p className="card-has-cremation-statement">{strings.cardGraveSiteList.hasCremationStatement}</p> : null
    }
    {contractHolderDeceased ?
      <p className="card-has-no-valid-contract">{strings.cardGraveSiteList.contractHolderDeceased}{deceasedContractGks ? (" ГКС: " + deceasedContractGks) : ""}</p> : null
    }
    {funeralAtDepth ?
      <p className="card-funeral-at-depth">{strings.cardGraveSiteList.funeralAtDepth}</p> : null
    }
  </div>
</React.Fragment>
);

export default CardGraveSiteHeader;